import { useState, useEffect, useCallback } from "react";
import { useApp } from "../context/AppContext";
import { Icons } from "../components/Icons";

const CHECKLIST = [
  { id: "access", group: "Доступи та аналітика", icon: "🔑", label: "Доступи",
    sub: "GSC, GA4, адмін-панель, хостинг, FTP",
    description: "Збираємо та перевіряємо повний набір доступів до проєкту: Google Search Console і Google Analytics 4, адмін-панель сайту (WordPress / OpenCart / Shopify тощо), хостинг (cPanel / ISPmanager), FTP/SFTP, за потреби — доступ до CMS-бази та DNS. Кожен доступ одразу тестуємо на вхід, а не просто фіксуємо логін-пароль.",
    goal: "Усі доступи зібрані, перевірені на працездатність і збережені в картці проєкту. Ми можемо самостійно зайти в GSC, GA4, адмінку й на хостинг без участі клієнта." },
  { id: "ga4_gsc", group: "Доступи та аналітика", icon: "📈", label: "Інтеграція GA4 + GSC", auto: "page",
    description: "Перевіряємо, що на сайті фізично встановлені й коректно працюють лічильники: Google Analytics 4 (gtag або через GTM), контейнер Google Tag Manager і код верифікації Search Console. Дивимося рендер скриптів у HTML і чи реально йдуть хіти у звіти.",
    goal: "GA4 збирає дані по всіх сторінках, GTM активний, домен підтверджено в GSC. У режимі реального часу видно власні візити — аналітика рахує трафік без втрат." },
  { id: "gsc_versions", group: "Доступи та аналітика", icon: "🌐", label: "Усі версії в GSC",
    sub: "http/https, www/без www",
    description: "Сайт у Search Console має бути доданий усіма технічними варіантами: http://, https://, з www і без www, а краще — доменною property через DNS. Різні версії Google трактує як окремі ресурси, тож частина кліків і показів може бути «розмазана» й невидима у звітах.",
    goal: "Додані всі версії + доменна property (Domain). Дані зведені в один ресурс, жоден сегмент трафіку не губиться у звітності GSC." },
  { id: "gmb", group: "Доступи та аналітика", icon: "🏪", label: "Google Business Profile",
    description: "Перевіряємо наявність і статус картки Google Business Profile (Google Maps): чи створена, підтверджена (верифікована), заповнені категорія, адреса, телефон, години роботи, фото, товари. Для локального бізнесу це прямий канал трафіку й дзвінків.",
    goal: "Картка існує, верифікована й заповнена, NAP (назва/адреса/телефон) збігається з сайтом. Компанія показується в Google Maps і локальній видачі." },

  { id: "indexation", group: "Індексація та сканування", icon: "🔍", label: "Покриття індексу",
    description: "Аналізуємо, скільки й яких сторінок реально в індексі Google: головна, категорії, підкатегорії, фільтри, картки товарів, блог. Через звіт GSC «Сторінки/Покриття» та оператор site: шукаємо недоіндексовані money-сторінки й, навпаки, «сміття» в індексі.",
    goal: "Є чітка картина: скільки важливих сторінок у індексі з наявних. Складено список недоіндексованих ключових сторінок і зайвих URL, які треба закрити." },
  { id: "pagespeed", group: "Індексація та сканування", icon: "⚡", label: "Швидкість і мобільна", auto: "pagespeed",
    description: "Міряємо швидкість і Core Web Vitals (LCP, CLS, INP/TBT, FCP) окремо для мобільної та десктоп версій через PageSpeed Insights / Lighthouse, враховуючи і лабораторні, і польові (CrUX) дані. Швидкість — прямий фактор ранжування й конверсії.",
    goal: "Зафіксовано базові показники швидкості по ключових шаблонах і конкретний список гальм (важкі зображення, блокуючий JS/CSS, повільний сервер) для оптимізації." },
  { id: "robots", group: "Індексація та сканування", icon: "🤖", label: "robots.txt", auto: "robots",
    description: "Перевіряємо файл robots.txt: наявність, директиви Allow/Disallow, відсутність випадкового блокування важливих розділів, коректне посилання на sitemap. Одна зайва директива тут може викинути весь сайт з індексу.",
    goal: "robots.txt валідний, не блокує потрібне, закриває службові розділи й містить рядок Sitemap:. За потреби — виправлена версія опублікована на сайт." },
  { id: "sanctions", group: "Індексація та сканування", icon: "⚠️", label: "Санкції GSC",
    description: "Перевіряємо Search Console на ручні санкції (Manual Actions), проблеми безпеки (злам, шкідливий код) і різкі просідання трафіку в історії. Якщо сайт під фільтром — інші роботи не дадуть результату, поки його не знято.",
    goal: "Підтверджено, що санкцій і проблем безпеки немає. Якщо є — зафіксовано причину й створено план зняття як задачу №1." },

  { id: "ssl", group: "Технічне", icon: "🔒", label: "SSL і HTTPS", auto: "ssl",
    description: "Перевіряємо дійсність SSL-сертифіката (термін, ланцюжок, збіг домену), примусовий HTTPS на всіх сторінках і відсутність mixed content (http-ресурси на https-сторінці). Небезпечне з’єднання = втрата довіри й позицій.",
    goal: "Сертифікат валідний, весь сайт віддається по HTTPS із 301-редиректом з http, mixed content відсутній. Браузер показує замок без попереджень." },
  { id: "sitemap", group: "Технічне", icon: "🗺️", label: "sitemap.xml", auto: "sitemap",
    description: "Перевіряємо sitemap.xml: наявність, валідність, актуальність (реальний lastmod), кількість URL і чи покриті всі важливі сторінки без сміття (noindex, 404, редиректи). Карта має бути зареєстрована в GSC і вказана в robots.txt.",
    goal: "Валідний актуальний sitemap містить лише потрібні URL, зареєстрований у GSC і Bing, прописаний у robots.txt. Google бачить повну структуру сайту." },
  { id: "www_redirect", group: "Технічне", icon: "↪️", label: "Склейка www",
    description: "Перевіряємо, що обрано одну головну версію домену (з www або без) і всі інші варіанти склеєні 301-редиректом в один канонічний хост. Інакше Google індексує два «дзеркала» й розмиває вагу сторінок.",
    goal: "Налаштований один канонічний хост, усі інші версії ведуть на нього 301-редиректом в один хоп. Дублів домену в індексі немає." },
  { id: "hreflang", group: "Технічне", icon: "🌍", label: "hreflang / lang", auto: "page",
    description: "Для мультимовних/регіональних сайтів перевіряємо атрибут html lang і теги hreflang: чи правильно вказані мовні/регіональні версії, чи є взаємні (двосторонні) посилання та self-референс, чи немає конфліктів з canonical.",
    goal: "hreflang коректний і двосторонній на всіх версіях, без помилок у GSC. Google показує потрібну мовну версію в потрібному регіоні без канібалізації." },

  { id: "affiliates", group: "Контент та URL", icon: "🔗", label: "Афіліати",
    description: "Шукаємо на сайті партнерські/affiliate/CPA-посилання, редиректи та тонкий «згенерований під партнерку» контент, які можуть тягнути сайт під фільтри за маніпулятивні вихідні посилання. Перевіряємо вихідні лінки й cloaking.",
    goal: "Підтверджено, що шкідливих affiliate-схем і масових вихідних посилань немає. Якщо знайдено — складено список на видалення або закриття rel-атрибутами." },
  { id: "human_urls", group: "Контент та URL", icon: "✨", label: "Людські URL",
    description: "Оцінюємо структуру URL: чи вони читабельні (ЧПУ) — /poslugi/manikur замість /index.php?id=42. Людські URL краще клікаються у видачі, легше інтерпретуються Google і зручніші для перелінковки.",
    goal: "Схема URL читабельна й послідовна (транслітерація, без параметрів у money-сторінках). За потреби — ТЗ на ЧПУ з 301-редиректами зі старих адрес." },
  { id: "js_filters", group: "Контент та URL", icon: "🧩", label: "JS-фільтри",
    description: "Перевіряємо, як працюють фільтри й сортування в каталозі: чи генерують вони окремі індексовані URL із SEO-цінністю (посадкові під «купити X у місті Y»), чи це чистий JavaScript без власних адрес, невидимий для Googlebot.",
    goal: "Зрозуміло, які фільтри дають SEO-потенціал і мають стати посадковими сторінками, а які лишити на JS або закрити. Складено план по пріоритетних фільтрах." },
  { id: "seo_text_render", group: "Контент та URL", icon: "📝", label: "Рендер SEO-текстів",
    description: "Перевіряємо, чи SEO-тексти на категоріях/лендінгах присутні у первинному HTML (server-side), який отримує Googlebot, а не підвантажуються лише JS після дії користувача. Текст, якого немає в HTML, часто не враховується.",
    goal: "Підтверджено, що SEO-контент і ключові елементи є у первинному HTML (перевірка через код сторінки / GSC Inspect). Якщо ні — складено ТЗ на SSR/рендер." },
  { id: "filter_urls", group: "Контент та URL", icon: "🔣", label: "URL фільтрів",
    description: "Аналізуємо патерн URL фільтрів і керування ними: canonical на батьківську категорію, noindex для непотрібних комбінацій, обробку GET-параметрів. Мета — не злити crawl-бюджет на мільйони беззмістовних комбінацій.",
    goal: "Визначено правила індексації фільтрів: цінні — відкриті з canonical=self, сміттєві — noindex/закриті. Crawl-бюджет витрачається на важливі сторінки." },

  { id: "competitor_analysis", group: "Додаткове", icon: "🏆", label: "Конкурентний аналіз", auto: "competitors",
    description: "Визначаємо 5–10 прямих SEO-конкурентів (хто реально в ТОПі за вашими запитами, не обов’язково бізнес-конкуренти) і збираємо їх метрики — Domain Rank, кількість посилань і реф-доменів, трафік — через OpenSEO. Це база для стратегії й прогнозів.",
    goal: "Сформовано список конкурентів із метриками в таблиці. Видно розрив по силі домену й посиланнях — зрозуміло, скільки ресурсу треба, щоб їх обійти." },
  { id: "subdomains", group: "Додаткове", icon: "🌳", label: "Піддомени", auto: "subdomains",
    description: "Через Certificate Transparency (crt.sh) і типові імена шукаємо всі піддомени (blog., en., dev., shop., m. тощо). Частина може дублювати контент, бути відкритою тестовою версією або, навпаки, корисним майданчиком для розвитку.",
    goal: "Складено перелік живих піддоменів з їх статусом. Визначено, що закрити від індексації (dev/test), що склеїти, а що розвивати." },
  { id: "test_order", group: "Додаткове", icon: "🛒", label: "Тестове замовлення",
    description: "Робимо реальне тестове замовлення/заявку й проходимо всю воронку до кінця. Перевіряємо, що спрацьовують аналітичні події (add_to_cart, begin_checkout, purchase/conversion) у GA4 та GTM і що ціль коректно фіксується.",
    goal: "Воронка працює без збоїв, конверсійні події долітають у GA4/GTM і рахуються як цілі. Можемо коректно вимірювати заявки/продажі з SEO." },

  { id: "og", group: "Розширені перевірки", icon: "🔖", label: "Open Graph / Twitter", auto: "page",
    description: "Перевіряємо теги Open Graph і Twitter Card (og:title, og:image, og:description) — вони формують прев’ю при шерінгу у Facebook, Telegram, месенджерах і впливають на CTR із соцмереж.",
    goal: "Ключові сторінки мають коректні OG-теги з валідним зображенням. Прев’ю при шерінгу виглядає акуратно, а не «голим» посиланням." },
  { id: "viewport", group: "Розширені перевірки", icon: "📱", label: "Мобільний viewport", auto: "page",
    description: "Перевіряємо мета-тег viewport (width=device-width) — без нього сайт не адаптується під мобільні, а Google використовує mobile-first індексацію.",
    goal: "viewport заданий коректно, сайт адаптивний. Mobile-first індексація без претензій." },
  { id: "schema", group: "Розширені перевірки", icon: "🧬", label: "Schema / JSON-LD", auto: "page",
    description: "Перевіряємо наявність структурованих даних JSON-LD (schema.org): Organization, Product, BreadcrumbList, FAQ тощо. Це дає розширені сніпети у видачі.",
    goal: "На сторінках є валідна JSON-LD розмітка під тип контенту. З’являються розширені результати (зірки, ціна, хлібні крихти, FAQ)." },
  { id: "mixed_content", group: "Розширені перевірки", icon: "🔓", label: "Mixed content", auto: "page",
    description: "Шукаємо mixed content — ресурси (зображення, скрипти, стилі), що підвантажуються по http на https-сторінці. Браузер їх блокує або показує попередження про небезпеку.",
    goal: "Mixed content відсутній — усі ресурси по https. Замок у браузері без попереджень, нічого не блокується." },
  { id: "security_headers", group: "Розширені перевірки", icon: "🛡️", label: "Security-заголовки", auto: "page",
    description: "Перевіряємо HTTP-заголовки безпеки: HSTS (strict-transport-security), CSP (content-security-policy), X-Frame-Options, X-Content-Type-Options. Впливають на безпеку й довіру.",
    goal: "Базові security-заголовки виставлені (принаймні HSTS і X-Content-Type-Options). Сайт захищений від типових атак." },
  { id: "ttfb", group: "Розширені перевірки", icon: "⏱️", label: "TTFB і вага сторінки", auto: "page",
    description: "Міряємо TTFB (час відповіді сервера до першого байта) і вагу HTML головної. Повільний сервер гальмує завантаження й погіршує Core Web Vitals незалежно від фронтенду.",
    goal: "TTFB у межах норми (< 600 мс), HTML не роздутий. Сервер відповідає швидко — добра база для швидкості." },
  { id: "sitemap_volume", group: "Розширені перевірки", icon: "📊", label: "Обсяг sitemap", auto: "sitemap",
    description: "Повністю розгортаємо sitemap: якщо це sitemap-index, заходимо в під-карти й рахуємо сумарну кількість URL. Порівнюємо з кількістю проіндексованих сторінок у GSC.",
    goal: "Відомий реальний обсяг sitemap (усі URL). Розрив між sitemap і індексом GSC виявлено — зрозуміло, скільки сторінок Google ще не взяв." },
  { id: "dns_cdn", group: "Розширені перевірки", icon: "🌐", label: "DNS / CDN / IP", auto: "dns",
    description: "Визначаємо IP-адреси домену (A-записи), наявність CDN (Cloudflare, Fastly, CloudFront) за заголовками, веб-сервер і приблизне гео/провайдера хостингу.",
    goal: "Відомо, де хоститься сайт, через який CDN іде трафік і які IP. Потрібно для діагностики швидкості, блокувань і egress-налаштувань." },

  { id: "eeat", group: "🤖 AI-перевірки", icon: "🧠", label: "AI E-E-A-T", auto: "eeat",
    description: "AI (gpt-4o) аналізує головну сторінку на сигнали E-E-A-T: автор/експерт, контакти (телефон, email, адреса), гарантії, відгуки, сторінка «Про нас», соцмережі. Повертає оцінку й чого бракує.",
    goal: "Отримано AI-оцінку довіри до сайту (0-100) і список відсутніх сигналів E-E-A-T. Зрозуміло, що додати, щоб підняти довіру Google (особливо для YMYL) і конверсію." },
];

const GROUPS = [...new Set(CHECKLIST.map(c => c.group))];
const STATUSES = [
  { value: "", label: "—", color: "#9ca3af", bg: "transparent" },
  { value: "ok", label: "OK", color: "#10b981", bg: "rgba(16,185,129,0.1)" },
  { value: "issue", label: "Проблема", color: "#ef4444", bg: "rgba(239,68,68,0.1)" },
  { value: "warning", label: "Увага", color: "#f59e0b", bg: "rgba(245,158,11,0.1)" },
  { value: "skip", label: "Пропущено", color: "#6b7280", bg: "rgba(107,114,128,0.1)" },
];

// Авто-статус пункту за результатами авто-перевірки (ok / warning / issue, або null — не чіпати).
function autoStatus(item, dd) {
  const p = dd.page || {};
  switch (item.id) {
    case "ssl": return dd.ssl ? (dd.ssl.ok ? "ok" : "issue") : null;
    case "sitemap": return dd.sitemap ? (dd.sitemap.ok ? "ok" : "issue") : null;
    case "sitemap_volume": return dd.sitemap ? ((dd.sitemap.ok && (dd.sitemap.totalUrls ?? dd.sitemap.urls) > 0) ? "ok" : "issue") : null;
    case "robots": return dd.robots ? (dd.robots.ok ? "ok" : "warning") : null;
    case "pagespeed": return dd.pagespeed ? (dd.pagespeed.performance >= 90 ? "ok" : dd.pagespeed.performance >= 50 ? "warning" : "issue") : null;
    case "ga4_gsc": return p.error ? null : ((p.hasGA || p.hasGTM) ? "ok" : "issue");
    case "og": return p.error ? null : ((p.ogTitle || p.ogImage || p.ogDesc) ? "ok" : "warning");
    case "viewport": return p.error ? null : (p.hasMobileViewport ? "ok" : "issue");
    case "schema": return p.error ? null : (p.hasSchema ? "ok" : "warning");
    case "mixed_content": return p.error ? null : (p.mixedContent > 0 ? "issue" : "ok");
    case "security_headers": { if (p.error) return null; const h = p.headers || {}; const n = ["strict-transport-security", "content-security-policy", "x-frame-options", "x-content-type-options"].filter(k => h[k]).length; return n >= 2 ? "ok" : "warning"; }
    case "ttfb": return (p.error || p.ttfb == null) ? null : (p.ttfb < 600 ? "ok" : p.ttfb < 1500 ? "warning" : "issue");
    case "dns_cdn": return (dd.dns && (dd.dns.ips || []).length) ? "ok" : null;
    case "eeat": return (dd.eeat && !dd.eeat.error) ? (dd.eeat.score >= 70 ? "ok" : dd.eeat.score >= 40 ? "warning" : "issue") : null;
    case "subdomains": return dd.subdomainsUnavailable ? null : (dd.subdomainsList ? "ok" : null);
    default: return null;
  }
}

export default function OnboardingView() {
  const { proj, activeId, apiFetch, flash, dark, t, card, inp, btnP, btnG, btnSm } = useApp();
  if (!proj) return null;

  const [data, setData] = useState({
    checklist: {},
    ssl: null, sitemap: null, robots: null, page: null, pagespeed: null,
    subdomains: "", subdomainsList: null,
  });
  const [loading, setLoading] = useState(true);
  const [checking, setChecking] = useState(false);
  const [checkProgress, setCheckProgress] = useState(null);
  const [expandedItem, setExpandedItem] = useState(null);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(null);
  const [competitors, setCompetitors] = useState([]);
  const [competitorsLoading, setCompetitorsLoading] = useState(false);
  const [competitorInput, setCompetitorInput] = useState("");
  const [refreshingCompetitors, setRefreshingCompetitors] = useState(false);
  const [robotsContent, setRobotsContent] = useState("");
  const [robotsOriginal, setRobotsOriginal] = useState("");
  const [robotsBusy, setRobotsBusy] = useState(false);
  const [robotsMsg, setRobotsMsg] = useState(null);

  useEffect(() => {
    if (!activeId) return;
    apiFetch(`/api/projects/${activeId}/onboarding`).then(r => r.json())
      .then(d => { if (d && typeof d === "object") setData(prev => ({ ...prev, ...d })); })
      .catch(() => {}).finally(() => setLoading(false));
  }, [activeId, apiFetch]);

  const loadCompetitors = useCallback(async () => {
    if (!activeId) return;
    setCompetitorsLoading(true);
    try {
      const r = await apiFetch(`/api/projects/${activeId}/onboarding/competitors`);
      const d = await r.json();
      if (r.ok) setCompetitors(d.competitors || []);
    } catch {} finally { setCompetitorsLoading(false); }
  }, [activeId, apiFetch]);

  useEffect(() => { loadCompetitors(); }, [loadCompetitors]);

  const saveCompetitorList = async (domains) => {
    try {
      const r = await apiFetch(`/api/projects/${activeId}/onboarding/competitors`, {
        method: "PUT", body: JSON.stringify({ competitors: domains }),
      });
      const d = await r.json();
      if (r.ok) await loadCompetitors();
      else flash(d.error || "Помилка збереження");
    } catch (e) { flash("Помилка: " + e.message); }
  };

  const addCompetitor = async () => {
    const v = competitorInput.trim();
    if (!v) return;
    const list = [...new Set([...competitors.map(c => c.domain), v])];
    setCompetitorInput("");
    await saveCompetitorList(list);
  };

  const removeCompetitor = async (domain) => {
    const list = competitors.map(c => c.domain).filter(d => d !== domain);
    await saveCompetitorList(list);
  };

  const loadRobotsFromSite = async () => {
    setRobotsBusy(true); setRobotsMsg(null);
    try {
      const r = await apiFetch(`/api/projects/${activeId}/sdk/robots`);
      const d = await r.json();
      if (r.ok) {
        setRobotsContent(d.content || "");
        setRobotsOriginal(d.content || "");
        setRobotsMsg({ ok: true, text: d.exists ? `✓ Прочитано (${d.bytes} байт) · ${d.path}` : `Файл не знайдено на сервері — можна створити` });
      } else flash(d.error || "Помилка");
    } catch (e) { flash("Помилка: " + e.message); }
    setRobotsBusy(false);
  };

  const saveRobotsToSite = async (confirmRisk = false) => {
    if (!robotsContent.trim()) { flash("Порожній robots.txt — нічого зберігати"); return; }
    setRobotsBusy(true); setRobotsMsg(null);
    try {
      const r = await apiFetch(`/api/projects/${activeId}/sdk/robots`, {
        method: "PUT", body: JSON.stringify({ content: robotsContent, confirmRisk }),
      });
      const d = await r.json();
      if (r.ok && d.ok) {
        setRobotsOriginal(robotsContent);
        setRobotsMsg({ ok: true, text: `✅ Опубліковано на сайт (${d.bytes} байт)` });
        flash("✓ robots.txt оновлено");
      } else if (d.warning) {
        const yes = window.confirm("⚠️ " + d.warning + "\n\nВсе одно опублікувати?");
        if (yes) await saveRobotsToSite(true);
        else setRobotsMsg({ ok: false, text: "Скасовано" });
      } else flash(d.error || "Помилка");
    } catch (e) { flash("Помилка: " + e.message); }
    setRobotsBusy(false);
  };

  const refreshCompetitors = async () => {
    if (!competitors.length) { flash("Спершу додайте конкурентів"); return; }
    setRefreshingCompetitors(true);
    try {
      const r = await apiFetch(`/api/projects/${activeId}/onboarding/competitors/refresh`, { method: "POST" });
      const d = await r.json();
      if (r.ok) {
        flash(`✓ Оновлено ${d.refreshed}/${d.total}${d.errors?.length ? ` · помилок: ${d.errors.length}` : ""}`);
        await loadCompetitors();
      } else flash(d.error || "Помилка");
    } catch (e) { flash("Помилка: " + e.message); }
    setRefreshingCompetitors(false);
  };

  const save = useCallback(async (newData) => {
    setSaving(true);
    try { await apiFetch(`/api/projects/${activeId}/onboarding`, { method: "PUT", body: JSON.stringify({ data: newData }) }); }
    catch {} setSaving(false);
  }, [activeId, apiFetch]);

  const uploadImage = async (itemId, dataUrl) => {
    setUploading(itemId);
    try {
      const r = await apiFetch(`/api/projects/${activeId}/onboarding/upload-image`, {
        method: "POST", body: JSON.stringify({ image: dataUrl, itemId }),
      });
      const d = await r.json();
      if (d.url) {
        const entry = data.checklist?.[itemId] || {};
        const images = [...(entry.images || []), d.url];
        updateChecklist(itemId, "images", images);
        flash("Скріншот додано");
      } else flash(d.error || "Помилка");
    } catch (e) { flash("Помилка: " + e.message); }
    setUploading(null);
  };

  const handlePaste = (e, itemId) => {
    const items = e.clipboardData?.items;
    if (!items) return;
    for (const item of items) {
      if (item.type.startsWith("image/")) {
        e.preventDefault();
        const file = item.getAsFile();
        const reader = new FileReader();
        reader.onload = () => uploadImage(itemId, reader.result);
        reader.readAsDataURL(file);
        return;
      }
    }
  };

  const handleFilePick = (e, itemId) => {
    const file = e.target.files?.[0];
    if (!file || !file.type.startsWith("image/")) return;
    const reader = new FileReader();
    reader.onload = () => uploadImage(itemId, reader.result);
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  const removeImage = (itemId, idx) => {
    const entry = data.checklist?.[itemId] || {};
    const images = (entry.images || []).filter((_, i) => i !== idx);
    updateChecklist(itemId, "images", images);
  };

  const updateChecklist = (id, field, value) => {
    const next = { ...data, checklist: { ...data.checklist, [id]: { ...(data.checklist?.[id] || {}), [field]: value } } };
    setData(next);
    save(next);
  };

  const runAutoCheck = async () => {
    setChecking(true); setCheckProgress({ step: "Початок...", current: 0, total: 9 });
    try {
      const token = localStorage.getItem("metago_token");
      const resp = await fetch(`/api/projects/${activeId}/onboarding/auto-check`, {
        method: "POST", headers: { Authorization: `Bearer ${token}` },
      });
      const reader = resp.body.getReader();
      const decoder = new TextDecoder();
      let buf = "";
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        const lines = buf.split("\n"); buf = lines.pop();
        for (const line of lines) {
          if (!line.startsWith("data: ")) continue;
          try {
            const msg = JSON.parse(line.slice(6));
            if (msg.type === "progress") setCheckProgress(msg);
            else if (msg.type === "result") {
              setData(prev => {
                const next = { ...prev };
                if (msg.key === "subdomains" && msg.value) {
                  next.subdomains = msg.value;
                } else if (msg.key === "subdomainsList") {
                  next.subdomainsList = msg.subdomains;
                  next.subdomainsUnavailable = !!msg.unavailable;
                  next.subdomainsPartial = !!msg.partial;
                } else {
                  next[msg.key] = msg;
                }
                save(next);
                return next;
              });
            } else if (msg.type === "done") {
              setCheckProgress(null);
              // Авто-проставляємо статуси пунктів за результатами перевірки
              setData(prev => {
                const cl = { ...(prev.checklist || {}) };
                for (const it of CHECKLIST) {
                  const st = autoStatus(it, prev);
                  if (st) cl[it.id] = { ...(cl[it.id] || {}), status: st, autoSet: true };
                }
                const next = { ...prev, checklist: cl };
                save(next);
                return next;
              });
              flash("Перевірку завершено ✓");
            }
          } catch {}
        }
      }
    } catch (e) { flash("Помилка: " + e.message); }
    setChecking(false); setCheckProgress(null);
  };

  const copyClientSummary = () => {
    const s = data.summary; if (!s) return;
    const lines = [];
    if (s.verdict) lines.push(s.verdict);
    if (s.summary) lines.push("", s.summary);
    if ((s.good || []).length) { lines.push("", "Що добре:"); s.good.forEach(g => lines.push("• " + g)); }
    if ((s.problems || []).length) { lines.push("", "Проблеми та рекомендації:"); s.problems.forEach(g => lines.push("• " + g)); }
    navigator.clipboard.writeText(lines.join("\n")).then(() => flash("Висновок скопійовано"), () => flash("Не вдалось скопіювати"));
  };

  const generatePDF = () => {
    const cl = data.checklist || {};
    const domain = proj.domain || "";
    const statusHTML = (s) => {
      const st = STATUSES.find(x => x.value === s) || STATUSES[0];
      return `<span style="color:${st.color};font-weight:700;padding:2px 8px;border-radius:4px;background:${st.bg};font-size:10px">${st.label}</span>`;
    };

    let rows = "";
    let currentGroup = "";
    CHECKLIST.forEach((item, i) => {
      if (item.group !== currentGroup) {
        currentGroup = item.group;
        rows += `<tr><td colspan="4" style="padding:10px 12px;font-weight:700;color:#6366f1;font-size:12px;background:rgba(99,102,241,0.04);border-bottom:2px solid #6366f1">${currentGroup}</td></tr>`;
      }
      const entry = cl[item.id] || {};
      const imagesHTML = (entry.images || []).map(url => `<img src="${url}" style="max-width:300px;max-height:200px;border-radius:4px;margin:4px 0;display:block" />`).join("");
      rows += `<tr><td style="padding:6px 12px;font-size:11px;border-bottom:1px solid #eee;width:30px;color:#999">${i + 1}</td><td style="padding:6px 12px;font-size:11px;border-bottom:1px solid #eee">${item.label}</td><td style="padding:6px 12px;border-bottom:1px solid #eee;width:100px;text-align:center">${statusHTML(entry.status || "")}</td><td style="padding:6px 12px;font-size:10px;color:#666;border-bottom:1px solid #eee">${entry.note || "—"}${imagesHTML}</td></tr>`;
    });

    const done = Object.values(cl).filter(v => v.status === "ok").length;
    const issues = Object.values(cl).filter(v => v.status === "issue").length;

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8">
<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
@page{size:A4;margin:15mm 20mm}*{box-sizing:border-box;margin:0;padding:0}body{font-family:'Inter',Arial,sans-serif;font-size:11px;color:#1a1a2e;line-height:1.6}
.doc{max-width:780px;margin:0 auto;padding:20px 0}
.header{display:flex;justify-content:space-between;align-items:flex-start;padding-bottom:20px;border-bottom:3px solid #6366f1;margin-bottom:20px}
.logo{font-size:28px;font-weight:700;color:#6366f1}.logo span{color:#a855f7}
h1{font-size:18px;font-weight:700;margin-bottom:8px;color:#1a1a2e}
.summary{display:flex;gap:20px;margin-bottom:20px;font-size:12px}
.summary div{padding:8px 16px;border-radius:8px;font-weight:600}
table{width:100%;border-collapse:collapse}th{padding:8px 12px;text-align:left;font-size:10px;color:#888;border-bottom:2px solid #ddd}
</style></head><body><div class="doc">
<div class="header"><div style="display:flex;align-items:center;gap:14px"><img src="${window.location.origin}/svitlo-logo.png" style="height:36px;width:auto" /><div><div style="font-size:22px;font-weight:800;color:#1a1a2e;letter-spacing:-0.3px">Svitlo Agency</div><div style="font-size:10px;color:#888">SEO-агенція повного циклу</div></div></div><div style="text-align:right;font-size:11px;color:#888">${new Date().toLocaleDateString("uk-UA")}</div></div>
<h1>SEO-онбординг: ${proj.name || domain}</h1>
<div class="summary">
<div style="background:rgba(16,185,129,0.1);color:#10b981">OK: ${done}</div>
<div style="background:rgba(239,68,68,0.1);color:#ef4444">Проблеми: ${issues}</div>
<div style="background:rgba(107,114,128,0.1);color:#6b7280">Всього: ${CHECKLIST.length}</div>
</div>
<table><thead><tr><th>#</th><th>Пункт перевірки</th><th>Статус</th><th>Коментар</th></tr></thead><tbody>${rows}</tbody></table>
<div style="margin-top:32px;padding:18px 20px;background:linear-gradient(135deg,rgba(99,102,241,0.06) 0%,rgba(168,85,247,0.04) 100%);border-radius:12px;border:1px solid #e5e7ff;display:flex;justify-content:space-between;align-items:center">
<div style="display:flex;align-items:center;gap:10px"><img src="${window.location.origin}/svitlo-logo.png" style="height:28px;width:auto" /><span style="font-size:13px;font-weight:700;color:#1a1a2e">Svitlo Agency</span></div>
<div style="display:flex;align-items:center;gap:8px;padding:6px 12px;background:#fff;border-radius:8px;border:1px solid #e5e7ff"><span style="font-size:10px;color:#888">Виконано через</span><img src="${window.location.origin}/logo.png" style="height:18px;width:auto" /><span style="font-size:13px;font-weight:800;color:#6366f1">Spalah</span><span style="font-size:8px;font-weight:700;color:#a855f7;background:rgba(168,85,247,0.12);padding:2px 6px;border-radius:4px">авторська розробка</span></div>
</div></div></body></html>`;

    const win = window.open("", "_blank");
    win.document.write(html);
    win.document.close();
    setTimeout(() => win.print(), 500);
  };

  if (loading) return <div style={{ textAlign: "center", padding: 40, color: t.textMuted }}>Завантаження...</div>;

  const cl = data.checklist || {};
  const doneCount = Object.values(cl).filter(v => v.status === "ok").length;
  const issueCount = Object.values(cl).filter(v => v.status === "issue").length;
  const pct = Math.round((doneCount / CHECKLIST.length) * 100);

  const getAutoInfo = (item) => {
    if (item.auto === "ssl" && data.ssl) return data.ssl.ok ? `SSL: ${data.ssl.status}` : `SSL: ${data.ssl.status}`;
    if (item.id === "sitemap_volume" && data.sitemap) return data.sitemap.ok ? `${data.sitemap.totalUrls ?? data.sitemap.urls} URL${data.sitemap.isIndex ? ` · ${data.sitemap.sitemaps} під-карт` : ""}` : "Не знайдено";
    if (item.auto === "sitemap" && data.sitemap) return data.sitemap.ok ? `Знайдено (${data.sitemap.urls} URL)` : "Не знайдено";
    if (item.auto === "robots" && data.robots) return data.robots.ok ? `Знайдено${data.robots.hasSitemap ? ", містить sitemap" : ""}` : "Не знайдено";
    if (item.auto === "pagespeed" && data.pagespeed) return `Performance: ${data.pagespeed.performance}, SEO: ${data.pagespeed.seo}`;
    if (item.auto === "subdomains") {
      if (data.subdomainsUnavailable) return "⚠️ crt.sh недоступне — спробуйте ще раз";
      if (data.subdomainsPartial && data.subdomainsList) return `${data.subdomainsList.filter(s => s.alive).length} живих (типові; crt.sh недоступне)`;
      if (data.subdomainsList) return `${data.subdomainsList.filter(s => s.alive).length} живих з ${data.subdomainsList.length}`;
    }
    if (item.auto === "dns" && data.dns) {
      const parts = [];
      if (data.dns.cdn && data.dns.cdn !== "немає") parts.push(data.dns.cdn);
      if ((data.dns.ips || [])[0]) parts.push(data.dns.ips[0]);
      if (data.dns.geo) parts.push(data.dns.geo.split(",")[0]);
      return parts.length ? parts.join(" · ") : "—";
    }
    if (item.auto === "eeat" && data.eeat) return data.eeat.error ? ("⚠️ " + data.eeat.error) : `E-E-A-T: ${data.eeat.score}/100`;
    if (item.auto === "page" && data.page) {
      if (item.id === "hreflang") return data.page.hreflang ? "hreflang знайдено" : "hreflang відсутній";
      if (item.id === "ga4_gsc") return `GTM: ${data.page.hasGTM ? "✓" : "✗"}, GA: ${data.page.hasGA ? "✓" : "✗"}, GSC: ${data.page.hasGSC ? "✓" : "✗"}`;
      if (item.id === "og") return (data.page.ogTitle || data.page.ogImage || data.page.ogDesc) ? `OG: ${data.page.ogTitle ? "title " : ""}${data.page.ogImage ? "image " : ""}${data.page.ogDesc ? "desc" : ""}`.trim() : "OG-теги відсутні";
      if (item.id === "viewport") return data.page.hasMobileViewport ? "viewport OK" : "немає mobile viewport";
      if (item.id === "schema") return data.page.hasSchema ? "JSON-LD знайдено" : "немає розмітки";
      if (item.id === "mixed_content") return data.page.mixedContent > 0 ? `⚠️ ${data.page.mixedContent} http-ресурсів` : "немає mixed content";
      if (item.id === "security_headers") { const h = data.page.headers || {}; const have = ["strict-transport-security", "content-security-policy", "x-frame-options", "x-content-type-options"].filter(k => h[k]).length; return `${have}/4 заголовків`; }
      if (item.id === "ttfb") return `TTFB ${data.page.ttfb}ms · ${data.page.htmlSize}KB`;
    }
    return null;
  };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
        <h2 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>{Icons.clipboard(16)} Онбординг</h2>
        {saving && <span style={{ fontSize: 10, color: "#6366f1" }}>зберігаю...</span>}
        <div style={{ marginLeft: "auto", display: "flex", gap: 6 }}>
          <button onClick={runAutoCheck} disabled={checking} style={{ ...btnP, fontSize: 12, opacity: checking ? 0.5 : 1 }}>
            {checking ? `${Icons.clock(12)} ${checkProgress?.step || "..."}` : `${Icons.search(12)} Авто-перевірка`}
          </button>
          <button onClick={generatePDF} style={{ ...btnG, fontSize: 12 }}>{Icons.fileText(12)} PDF</button>
        </div>
      </div>

      {/* Progress bar for auto-check */}
      {checkProgress && (
        <div style={{ height: 4, borderRadius: 2, background: dark ? "#333" : "#e5e7eb", marginBottom: 12, overflow: "hidden" }}>
          <div style={{ height: "100%", width: `${(checkProgress.current / checkProgress.total) * 100}%`, background: "#6366f1", borderRadius: 2, transition: "width .3s" }} />
        </div>
      )}

      {/* Summary bar */}
      <div style={{ ...card, padding: 14, marginBottom: 12, display: "flex", alignItems: "center", gap: 16 }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
            <span style={{ fontSize: 22, fontWeight: 800, color: pct >= 80 ? "#10b981" : pct >= 40 ? "#f59e0b" : "#ef4444" }}>{pct}%</span>
            <span style={{ fontSize: 11, color: t.textMuted }}>завершено</span>
          </div>
          <div style={{ height: 6, borderRadius: 3, background: dark ? "#333" : "#e5e7eb", overflow: "hidden" }}>
            <div style={{ height: "100%", width: `${pct}%`, background: pct >= 80 ? "#10b981" : pct >= 40 ? "#f59e0b" : "#ef4444", borderRadius: 3, transition: "width .3s" }} />
          </div>
        </div>
        <div style={{ display: "flex", gap: 12 }}>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#10b981" }}>{doneCount}</div>
            <div style={{ fontSize: 9, color: t.textMuted }}>OK</div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#ef4444" }}>{issueCount}</div>
            <div style={{ fontSize: 9, color: t.textMuted }}>Проблем</div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 18, fontWeight: 800, color: t.textMuted }}>{CHECKLIST.length - doneCount - issueCount}</div>
            <div style={{ fontSize: 9, color: t.textMuted }}>Залишилось</div>
          </div>
        </div>
      </div>

      {/* AI-висновок для клієнта + скрін сайту */}
      {(data.summary || data.screenshot) && (
        <div style={{ ...card, padding: 16, marginBottom: 14, borderLeft: "3px solid #6366f1" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
            <span style={{ fontSize: 13, fontWeight: 800 }}>🧾 Висновок для клієнта</span>
            {data.summary?.score != null && (
              <span style={{ fontSize: 12, fontWeight: 800, color: "#fff", background: data.summary.score >= 70 ? "#10b981" : data.summary.score >= 40 ? "#f59e0b" : "#ef4444", borderRadius: 12, padding: "2px 10px" }}>{data.summary.score}/100</span>
            )}
            {data.summary && (
              <button onClick={copyClientSummary} style={{ ...btnG, fontSize: 10, padding: "4px 10px", marginLeft: "auto" }}>📋 Скопіювати</button>
            )}
          </div>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
            <div style={{ flex: "1 1 320px", minWidth: 280 }}>
              {data.summary?.verdict && <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>{data.summary.verdict}</div>}
              {data.summary?.summary && <div style={{ fontSize: 12.5, color: t.text, lineHeight: 1.5, marginBottom: 10 }}>{data.summary.summary}</div>}
              {(data.summary?.good || []).length > 0 && (
                <div style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: "#10b981", textTransform: "uppercase", marginBottom: 4 }}>✅ Що добре</div>
                  <ul style={{ margin: 0, paddingLeft: 18, fontSize: 12, lineHeight: 1.5 }}>{data.summary.good.map((g, i) => <li key={i}>{g}</li>)}</ul>
                </div>
              )}
              {(data.summary?.problems || []).length > 0 && (
                <div>
                  <div style={{ fontSize: 10, fontWeight: 700, color: "#ef4444", textTransform: "uppercase", marginBottom: 4 }}>⚠️ Проблеми / що робити</div>
                  <ul style={{ margin: 0, paddingLeft: 18, fontSize: 12, lineHeight: 1.5 }}>{data.summary.problems.map((g, i) => <li key={i}>{g}</li>)}</ul>
                </div>
              )}
              {!data.summary && data.screenshot && <div style={{ fontSize: 12, color: t.textMuted }}>Запустіть авто-перевірку, щоб згенерувати висновок.</div>}
            </div>
            {data.screenshot?.url && (
              <div style={{ flex: "0 0 auto" }}>
                <div style={{ fontSize: 10, color: t.textMuted, marginBottom: 4 }}>Скрін головної</div>
                <img src={data.screenshot.url} alt="screenshot" style={{ width: 200, maxHeight: 360, objectFit: "cover", objectPosition: "top", border: `1px solid ${t.border}`, borderRadius: 8, cursor: "zoom-in", display: "block" }} onClick={() => window.open(data.screenshot.url, "_blank")} />
              </div>
            )}
          </div>
        </div>
      )}

      {/* Checklist grouped — grid of cards */}
      {GROUPS.map(group => (
        <div key={group} style={{ marginBottom: 18 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: "#6366f1", textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 8, padding: "0 2px" }}>
            {group} · {CHECKLIST.filter(c => c.group === group).length}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 10 }}>
            {CHECKLIST.filter(c => c.group === group).map((item) => {
              const entry = cl[item.id] || {};
              const autoInfo = getAutoInfo(item);
              const statusObj = STATUSES.find(s => s.value === (entry.status || "")) || STATUSES[0];
              const barColor = entry.status === "ok" ? "#10b981" : entry.status === "issue" ? "#ef4444" : entry.status === "warning" ? "#f59e0b" : entry.status === "skip" ? "#6b7280" : dark ? "#2a2a3a" : "#e5e7eb";

              return (
                <div
                  key={item.id}
                  onClick={() => setExpandedItem(item.id)}
                  style={{
                    ...card, padding: 0, cursor: "pointer",
                    position: "relative", overflow: "hidden",
                    transition: "transform .12s, box-shadow .12s",
                    minHeight: 138,
                    display: "flex", flexDirection: "column",
                  }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = dark ? "0 4px 18px rgba(99,102,241,0.20)" : "0 4px 18px rgba(0,0,0,0.06)"; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = ""; }}
                >
                  {/* Status bar */}
                  <div style={{ height: 3, background: barColor, flexShrink: 0 }} />

                  <div style={{ padding: "12px 14px", flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
                    {/* Header: icon + label + status badge */}
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                      <span style={{ fontSize: 18, lineHeight: 1, flexShrink: 0 }}>{item.icon || "•"}</span>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 13, fontWeight: 700, lineHeight: 1.25, color: t.text }}>{item.label}</div>
                        {item.sub && <div style={{ fontSize: 10, color: t.textMuted, marginTop: 2 }}>{item.sub}</div>}
                      </div>
                      {entry.status && (
                        <span style={{ fontSize: 9, fontWeight: 700, padding: "2px 7px", borderRadius: 4, background: statusObj.bg, color: statusObj.color, flexShrink: 0, whiteSpace: "nowrap" }}>
                          {statusObj.label}
                        </span>
                      )}
                    </div>

                    {/* Description */}
                    {item.description && (
                      <div style={{ fontSize: 11, color: t.textMuted, lineHeight: 1.4, flex: 1 }}>
                        {item.description}
                      </div>
                    )}

                    {/* Auto info */}
                    {autoInfo && (
                      <div style={{ fontSize: 10, color: "#6366f1", padding: "4px 8px", background: dark ? "rgba(99,102,241,0.08)" : "rgba(99,102,241,0.06)", borderRadius: 4, fontWeight: 600 }}>
                        {autoInfo}
                      </div>
                    )}

                    {/* Footer indicators */}
                    <div style={{ display: "flex", gap: 8, fontSize: 10, color: t.textMuted, marginTop: "auto" }}>
                      {entry.note && <span title={entry.note}>📝 нотатка</span>}
                      {(entry.images || []).length > 0 && <span>📷 {entry.images.length}</span>}
                      {!entry.status && !entry.note && !(entry.images || []).length && <span style={{ fontStyle: "italic" }}>натисніть щоб заповнити</span>}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {/* Side drawer editor (slides in from the right) */}
      {expandedItem && (() => {
        const item = CHECKLIST.find(c => c.id === expandedItem);
        if (!item) return null;
        const entry = cl[item.id] || {};
        const autoInfo = getAutoInfo(item);
        return (
          <div
            onClick={() => setExpandedItem(null)}
            style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1000, display: "flex", alignItems: "stretch", justifyContent: "flex-end", animation: "onbFadeIn .18s ease" }}
          >
            <style>{`@keyframes onbDrawerIn{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes onbFadeIn{from{opacity:0}to{opacity:1}}`}</style>
            <div
              onClick={e => e.stopPropagation()}
              style={{
                ...card, padding: 0, width: "min(560px, 100%)", height: "100vh", maxHeight: "100vh", overflow: "auto", borderRadius: 0,
                background: dark ? "#0f0f1c" : "#fff",
                boxShadow: "-8px 0 30px rgba(0,0,0,0.25)", animation: "onbDrawerIn .24s cubic-bezier(.4,0,.2,1)",
              }}
            >
              <div style={{ padding: "16px 20px", borderBottom: `1px solid ${t.border}`, display: "flex", alignItems: "center", gap: 10, position: "sticky", top: 0, zIndex: 2, background: dark ? "#0f0f1c" : "#fff" }}>
                <span style={{ fontSize: 22 }}>{item.icon || "•"}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 15, fontWeight: 700 }}>{item.label}</div>
                  <div style={{ fontSize: 10, color: t.textMuted, textTransform: "uppercase", letterSpacing: 0.5 }}>{item.group}</div>
                </div>
                <button onClick={() => setExpandedItem(null)} style={{ background: "transparent", border: "none", fontSize: 20, color: t.textMuted, cursor: "pointer", lineHeight: 1 }}>×</button>
              </div>

              <div style={{ padding: 20, display: "flex", flexDirection: "column", gap: 14 }}>
                {item.description && (
                  <div>
                    <div style={{ fontSize: 10, fontWeight: 700, color: t.textMuted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Що це / що перевіряємо</div>
                    <div style={{ fontSize: 12.5, color: t.text, lineHeight: 1.55, padding: "10px 14px", background: dark ? "rgba(99,102,241,0.05)" : "rgba(99,102,241,0.04)", borderRadius: 8, borderLeft: "3px solid #6366f1" }}>
                      {item.description}
                    </div>
                  </div>
                )}

                {item.goal && (
                  <div>
                    <div style={{ fontSize: 10, fontWeight: 700, color: "#10b981", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>✅ Що треба отримати (результат)</div>
                    <div style={{ fontSize: 12.5, color: t.text, lineHeight: 1.55, padding: "10px 14px", background: dark ? "rgba(16,185,129,0.06)" : "rgba(16,185,129,0.05)", borderRadius: 8, borderLeft: "3px solid #10b981" }}>
                      {item.goal}
                    </div>
                  </div>
                )}

                <div>
                  <div style={{ fontSize: 10, fontWeight: 700, color: t.textMuted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Статус</div>
                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                    {STATUSES.map(s => (
                      <button
                        key={s.value}
                        onClick={() => updateChecklist(item.id, "status", s.value)}
                        style={{
                          fontSize: 11, fontWeight: 600, padding: "6px 12px", borderRadius: 6, cursor: "pointer",
                          border: (entry.status || "") === s.value ? `2px solid ${s.color}` : `1px solid ${dark ? "#333" : "#e5e7eb"}`,
                          background: (entry.status || "") === s.value ? s.bg : "transparent",
                          color: (entry.status || "") === s.value ? s.color : t.textMuted,
                        }}
                      >
                        {s.label}
                      </button>
                    ))}
                  </div>
                </div>

                {autoInfo && (
                  <div style={{ fontSize: 12, color: "#6366f1", padding: "8px 12px", background: dark ? "rgba(99,102,241,0.08)" : "rgba(99,102,241,0.05)", borderRadius: 6, fontWeight: 600 }}>
                    Авто-перевірка: {autoInfo}
                  </div>
                )}

                {item.id === "pagespeed" && data.pagespeed && (
                  <div style={{ display: "flex", gap: 14 }}>
                    {[["Performance", data.pagespeed.performance], ["SEO", data.pagespeed.seo]].map(([label, score]) => (
                      <div key={label} style={{ textAlign: "center" }}>
                        <div style={{ width: 56, height: 56, borderRadius: "50%", background: score >= 90 ? "#10b981" : score >= 50 ? "#f59e0b" : "#ef4444", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 800, fontSize: 18 }}>{score}</div>
                        <div style={{ fontSize: 10, color: t.textMuted, marginTop: 4 }}>{label}</div>
                      </div>
                    ))}
                  </div>
                )}

                {item.id === "competitor_analysis" && (
                  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    {/* Add competitor */}
                    <div style={{ display: "flex", gap: 6 }}>
                      <input
                        value={competitorInput}
                        onChange={e => setCompetitorInput(e.target.value)}
                        onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); addCompetitor(); } }}
                        placeholder="competitor-site.com"
                        style={{ ...inp, flex: 1, fontSize: 12 }}
                      />
                      <button onClick={addCompetitor} disabled={!competitorInput.trim()} style={{ ...btnP, fontSize: 11, padding: "6px 14px", opacity: !competitorInput.trim() ? 0.5 : 1 }}>
                        + Додати
                      </button>
                      <button onClick={refreshCompetitors} disabled={refreshingCompetitors || !competitors.length} style={{ ...btnG, fontSize: 11, padding: "6px 12px", opacity: refreshingCompetitors || !competitors.length ? 0.5 : 1 }}>
                        {refreshingCompetitors ? "Тягну..." : "↻ Оновити метрики"}
                      </button>
                    </div>

                    {/* Competitors table */}
                    {competitorsLoading ? (
                      <div style={{ fontSize: 11, color: t.textMuted, textAlign: "center", padding: 20 }}>Завантаження…</div>
                    ) : competitors.length === 0 ? (
                      <div style={{ fontSize: 11, color: t.textMuted, textAlign: "center", padding: 20, border: `1px dashed ${t.border}`, borderRadius: 6 }}>
                        Конкурентів ще не додано. Впишіть домен вище → "Додати". Потім натисніть "Оновити метрики" — підтягнемо Domain Rank/посилання/трафік з OpenSEO.
                      </div>
                    ) : (
                      <div style={{ border: `1px solid ${t.border}`, borderRadius: 6, overflow: "hidden" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "1.6fr 70px 90px 90px 90px 30px", gap: 0, padding: "6px 10px", background: dark ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)", fontSize: 10, fontWeight: 700, color: t.textMuted, textTransform: "uppercase", letterSpacing: 0.4 }}>
                          <div>Домен</div><div style={{ textAlign: "right" }}>Rank</div><div style={{ textAlign: "right" }}>Посилань</div><div style={{ textAlign: "right" }}>Реф.доменів</div><div style={{ textAlign: "right" }}>Трафік</div><div></div>
                        </div>
                        {competitors.map(c => (
                          <div key={c.domain} style={{ display: "grid", gridTemplateColumns: "1.6fr 70px 90px 90px 90px 30px", gap: 0, padding: "8px 10px", borderTop: `1px solid ${t.border}`, fontSize: 12, alignItems: "center" }}>
                            <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              <a href={`https://${c.domain}`} target="_blank" rel="noopener noreferrer" style={{ color: t.text, textDecoration: "none", fontWeight: 600 }}>{c.domain}</a>
                              {c.error && <div style={{ fontSize: 9, color: "#ef4444", marginTop: 2 }}>⚠ {c.error.slice(0, 60)}</div>}
                              {!c.error && c.fetchedAt && <div style={{ fontSize: 9, color: t.textMuted, marginTop: 2 }}>{new Date(c.fetchedAt).toLocaleDateString("uk-UA")}</div>}
                            </div>
                            <div style={{ textAlign: "right", fontFamily: "monospace", fontWeight: 700, color: c.rank == null ? t.textMuted : c.rank >= 60 ? "#ef4444" : c.rank >= 30 ? "#f59e0b" : "#10b981" }}>
                              {c.rank == null ? "—" : c.rank}
                            </div>
                            <div style={{ textAlign: "right", fontFamily: "monospace", color: t.text }}>{c.backlinks == null ? "—" : c.backlinks.toLocaleString("uk-UA")}</div>
                            <div style={{ textAlign: "right", fontFamily: "monospace", color: t.text }}>{c.referringDomains == null ? "—" : c.referringDomains.toLocaleString("uk-UA")}</div>
                            <div style={{ textAlign: "right", fontFamily: "monospace", color: t.text }}>{c.traffic == null ? "—" : c.traffic.toLocaleString("uk-UA")}</div>
                            <div style={{ textAlign: "right" }}>
                              <button onClick={() => removeCompetitor(c.domain)} title="Видалити" style={{ background: "transparent", border: "none", color: t.textMuted, cursor: "pointer", fontSize: 14, padding: 2 }}>×</button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <div style={{ fontSize: 10, color: t.textMuted }}>
                      Метрики тягнуться з OpenSEO. Якщо OpenSEO не підключено — додайте через дашборд проєкту.
                    </div>
                  </div>
                )}

                {item.id === "subdomains" && data.subdomainsList && data.subdomainsList.length > 0 && (
                  <div style={{ maxHeight: 200, overflowY: "auto", border: `1px solid ${t.border}`, borderRadius: 6 }}>
                    {data.subdomainsList.map((s, i) => (
                      <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, padding: "5px 10px", fontSize: 12, background: s.alive ? "rgba(16,185,129,0.04)" : "rgba(239,68,68,0.04)" }}>
                        <span style={{ width: 7, height: 7, borderRadius: "50%", background: s.alive ? "#10b981" : "#ef4444" }} />
                        <span style={{ flex: 1 }}>{s.subdomain}</span>
                        {s.alive && <span style={{ fontSize: 10, color: "#10b981" }}>{s.status}</span>}
                      </div>
                    ))}
                  </div>
                )}

                {item.id === "eeat" && data.eeat && !data.eeat.error && (
                  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div style={{ width: 48, height: 48, borderRadius: "50%", flexShrink: 0, background: data.eeat.score >= 70 ? "#10b981" : data.eeat.score >= 40 ? "#f59e0b" : "#ef4444", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 16 }}>{data.eeat.score}</div>
                      <div style={{ fontSize: 12, color: t.text, lineHeight: 1.45 }}>{data.eeat.summary}</div>
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                      {[["Автор", data.eeat.author], ["Контакти", data.eeat.contacts], ["Гарантії", data.eeat.guarantees], ["Відгуки", data.eeat.reviews], ["Про нас", data.eeat.about]].map(([lbl, v]) => (
                        <span key={lbl} style={{ fontSize: 11, padding: "3px 9px", borderRadius: 12, background: v ? "rgba(16,185,129,0.12)" : "rgba(239,68,68,0.10)", color: v ? "#10b981" : "#ef4444", fontWeight: 600 }}>{v ? "✓" : "✗"} {lbl}</span>
                      ))}
                    </div>
                    {(data.eeat.missing || []).length > 0 && (
                      <div style={{ fontSize: 11, color: t.textMuted, lineHeight: 1.4 }}>Бракує: {data.eeat.missing.join("; ")}</div>
                    )}
                  </div>
                )}
                {item.id === "eeat" && data.eeat && data.eeat.error && (
                  <div style={{ fontSize: 12, color: "#ef4444" }}>⚠️ {data.eeat.error}</div>
                )}

                {item.id === "dns_cdn" && data.dns && (
                  <div style={{ display: "flex", flexDirection: "column", gap: 6, fontSize: 12, padding: "10px 14px", background: dark ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)", borderRadius: 8 }}>
                    <div><b>IP:</b> {(data.dns.ips || []).join(", ") || "—"}</div>
                    <div><b>CDN:</b> {data.dns.cdn}</div>
                    {data.dns.server && <div><b>Сервер:</b> {data.dns.server}</div>}
                    {data.dns.powered && <div><b>Powered-by:</b> {data.dns.powered}</div>}
                    {data.dns.geo && <div><b>Гео / хостинг:</b> {data.dns.geo}</div>}
                  </div>
                )}

                {item.id === "robots" && (
                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    {data.robots?.content && !robotsOriginal && (
                      <pre style={{ fontSize: 11, background: dark ? "#0a0a14" : "#f9fafb", padding: 12, borderRadius: 6, maxHeight: 160, overflow: "auto", whiteSpace: "pre-wrap" }}>{data.robots.content}</pre>
                    )}
                    <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
                      <button onClick={loadRobotsFromSite} disabled={robotsBusy} style={{ ...btnG, fontSize: 11, padding: "6px 12px" }}>
                        {robotsBusy ? "..." : "📥 Прочитати з сайту (FTP)"}
                      </button>
                      <button
                        onClick={() => saveRobotsToSite(false)}
                        disabled={robotsBusy || !robotsContent || robotsContent === robotsOriginal}
                        style={{ background: "#10b981", color: "#fff", border: "none", borderRadius: 6, padding: "6px 14px", fontSize: 11, fontWeight: 600, cursor: "pointer", opacity: (!robotsContent || robotsContent === robotsOriginal) ? 0.4 : 1 }}>
                        🚀 Опублікувати на сайт
                      </button>
                      {robotsContent !== robotsOriginal && robotsOriginal && (
                        <span style={{ fontSize: 10, color: "#f59e0b", fontWeight: 600 }}>● незбережені зміни</span>
                      )}
                    </div>
                    {robotsMsg && (
                      <div style={{ fontSize: 11, padding: "6px 10px", borderRadius: 6, background: robotsMsg.ok ? "rgba(16,185,129,0.10)" : "rgba(239,68,68,0.10)", color: robotsMsg.ok ? "#10b981" : "#ef4444" }}>
                        {robotsMsg.text}
                      </div>
                    )}
                    <textarea
                      value={robotsContent}
                      onChange={e => setRobotsContent(e.target.value)}
                      placeholder="# Натисніть 'Прочитати з сайту' щоб завантажити поточний robots.txt&#10;# Або введіть директиви вручну:&#10;&#10;User-agent: *&#10;Disallow: /admin/&#10;Allow: /&#10;&#10;Sitemap: https://example.com/sitemap.xml"
                      style={{ ...inp, fontFamily: "monospace", fontSize: 12, minHeight: 220, resize: "vertical", width: "100%", boxSizing: "border-box" }}
                    />
                    <div style={{ fontSize: 10, color: t.textMuted, lineHeight: 1.4 }}>
                      Працює через FTP-доступи проєкту. Файл пишеться у <code>&lt;ftp_root&gt;/robots.txt</code>. Перед публікацією перевіряємо що нема <code>User-agent: * + Disallow: /</code> (інакше випадете з індексу).
                    </div>
                  </div>
                )}

                <div>
                  <div style={{ fontSize: 10, fontWeight: 700, color: t.textMuted, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Коментар / нотатки</div>
                  <textarea
                    value={entry.note || ""}
                    onChange={e => updateChecklist(item.id, "note", e.target.value)}
                    onPaste={e => handlePaste(e, item.id)}
                    placeholder="Деталі перевірки... (Ctrl+V щоб вставити скріншот)"
                    rows={4}
                    style={{ ...inp, fontSize: 12, resize: "vertical", width: "100%", boxSizing: "border-box" }}
                  />
                </div>

                <div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <label style={{ fontSize: 11, color: "#6366f1", cursor: "pointer", fontWeight: 700 }}>
                      + Додати скріншот
                      <input type="file" accept="image/*" onChange={e => handleFilePick(e, item.id)} style={{ display: "none" }} />
                    </label>
                    {uploading === item.id && <span style={{ fontSize: 10, color: t.textMuted }}>завантажую...</span>}
                  </div>
                  {(entry.images || []).length > 0 && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 10 }}>
                      {(entry.images || []).map((url, imgIdx) => (
                        <div key={imgIdx} style={{ position: "relative" }}>
                          <img src={url} alt="" style={{ width: "100%", height: "auto", maxHeight: "75vh", objectFit: "contain", borderRadius: 6, border: `1px solid ${t.border}`, cursor: "zoom-in", display: "block" }} onClick={() => window.open(url, "_blank")} />
                          <button onClick={() => removeImage(item.id, imgIdx)} style={{ position: "absolute", top: 4, right: 4, background: "rgba(0,0,0,0.7)", color: "#fff", border: "none", borderRadius: "50%", width: 22, height: 22, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", lineHeight: 1 }}>×</button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}
